"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoclipsApiErrorFactory = void 0;
class BoclipsApiErrorFactory {
    static sample(apiError = {}) {
        const defaults = {
            error: 'Bad Request',
            message: 'your request failed because of reasons',
            path: '/v1/orders',
            status: 400,
            timestamp: new Date(),
        };
        return { ...defaults, ...apiError };
    }
}
exports.BoclipsApiErrorFactory = BoclipsApiErrorFactory;
//# sourceMappingURL=BoclipsApiErrorFactory.js.map